import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { filter, interval, Subscription, tap } from 'rxjs';
import { calcAgo } from '@mri/functions';

@Component({
  selector: 'app-duration-text',
  template: `<label (ngxVisibility)="onVisible($event)" >{{ value }}</label>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DurationTextComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();
  private _dateValue:string | Date;

  show = true;
  value = '';

  @Input() set dateValue( value: string | Date){
    this._dateValue = value;
    this.value = calcAgo(this._dateValue);
  }

  constructor(
    private _ref : ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this._subscription.add(
      interval(1000)
        .pipe(
          filter(() => this.show),
          tap(() =>{
            if(!this._dateValue) return;
            const newValue = calcAgo(this._dateValue);
            if(this.value === newValue) return;

            this.value = newValue;
            this._ref.markForCheck();
          })
        )
        .subscribe()
    );
  }

  onVisible(show: boolean){
    if(this.show === show) return;

    this.show = show;
    this._ref.markForCheck();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }


}
